import { memo } from "react";
import HomeSection from "../components/widget/HomeSection/HomeSection";
import Title from "../components/widget/Title/Title";
import { preStaticUrl } from "../../../constants/env_config";
import "./BackerSection.scss";
const arr = [
  "/logos/funding-signum-captial.webp",
  "/logos/funding-uob.webp",
  "/logos/funding-dwf.svg",
  "/logos/funding-hong-leong.webp",
  "/logos/funding-cogitent.webp",
  "/logos/funding-hashkey-capital.webp",
  "/logos/funding-catchervc.webp",
  "/logos/funding-hydrogenesis-labs.webp",
];
const BackerSection = memo(
  () => {
    return (
      <HomeSection id="BackerSection" classNames="backer_section">
        <Title title="Backers" />
        <div className="backer_section_inner">
          {arr.map((v) => (
            <div key={v} style={{ backgroundImage: `url(${v})` }} />
          ))}
        </div>
      </HomeSection>
    );
  },
  () => false
);
export default BackerSection;
